import { motion } from 'framer-motion'
import { useTranslation } from 'react-i18next'

export default function LangToggle() {
  const { i18n } = useTranslation()
  const isEs = i18n.language?.startsWith('es')

  return (
    <motion.button
      className="lang-toggle"
      onClick={() => i18n.changeLanguage(isEs ? 'en' : 'es')}
      aria-label={isEs ? 'Switch to English' : 'Cambiar a Español'}
      title={isEs ? 'English' : 'Español'}
      whileTap={{ scale: 0.85 }}
      transition={{ type: 'spring', stiffness: 400, damping: 17 }}
    >
      {isEs ? 'EN' : 'ES'}
    </motion.button>
  )
}
